import {
    Navbar as FeNavbar,
    NavbarContent,
    NavbarTitle,
    NavbarToggleButton,
} from "@jhool-io/fe-components";
import { useAppDispatch, useAppSelector } from "../../hooks/useRedux";
import { toggleNavState } from "../../redux/features/nav/navSlice";
import { useFetchUserDetails } from "../../modules/auth/hooks/auth.queries";
import useCurrentClientProfile from "../../hooks/useCurrentClient";
import ProfilePracticeSwitcher from "../ProfilePracticeSwitcher/ProfilePracticeSwitcher";

interface NavProps {
    title?: string;
}

export default function Navbar({ title }: NavProps) {
    const { isOpen } = useAppSelector((state) => state.nav);

    const dispatch = useAppDispatch();

    const { data: loggedInUserData, isSuccess } = useFetchUserDetails();

    const currentProfile = useCurrentClientProfile();

    return (
        <FeNavbar className="px-16 md:px-32 py-16 md:py-20 justify-between items-center gap-x-12">
            <div className="flex items-center gap-x-8 min-w-0">
                {isOpen ? null : (
                    <NavbarToggleButton
                        className="px-4 shrink-0"
                        aria-label="Open menu"
                        onClick={() => dispatch(toggleNavState())}
                    />
                )}
                <NavbarTitle className="font-semibold text-lg capitalize truncate">
                    {title ?? "Patient Portal"}
                </NavbarTitle>
            </div>

            {isSuccess && loggedInUserData && currentProfile && (
                <NavbarContent>
                    <ProfilePracticeSwitcher />
                </NavbarContent>
            )}
        </FeNavbar>
    );
}
